import Api from '@/api/api.js'

export default {
    getListeMotifs() {
        const promise = Api().get('/consultations/motifs')
        return promise.then((response) => response.data)
    },

    getConsultationMotifs(data) {
        const promise = Api().post('/consultations/motifs/liste', data)
        return promise.then((response) => response.data)
    },

    saveConsultationMotif(data) {
        const promise = Api().post('/consultations/motifs/store', data)
        return promise.then((response) => response.data)
    },

    removeConsultationMotif(data) {
        const promise = Api().put('/consultations/motifs/remove', data)
        return promise.then((response) => response.data)
    },

    removeConsultationGroupMotif(data) {
        const promise = Api().put('/consultations/motifs/group/remove', data)
        return promise.then((response) => response.data)
    },
}